import React, { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';

const Layout = ({ children }) => {
  const { pathname, hash } = useLocation();
  const isMessagingRoute = pathname.startsWith('/messages');

  useLayoutEffect(() => {
    const targetId = hash ? decodeURIComponent(hash.slice(1)) : '';
    const target = targetId ? document.getElementById(targetId) : null;

    if (target) {
      target.scrollIntoView({ block: 'start' });
    } else {
      window.scrollTo(0, 0);
    }
    document.documentElement.style.overflow = isMessagingRoute ? 'hidden' : '';
    document.body.style.overflow = isMessagingRoute ? 'hidden' : '';

    return () => {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    };
  }, [pathname, hash, isMessagingRoute]);

  return (
    <div
      className={
        isMessagingRoute
          ? 'flex h-screen min-w-0 flex-col overflow-hidden'
          : 'flex min-h-screen min-w-0 flex-col overflow-x-clip'
      }
    >
      <Navbar />
      <main
        className={
        isMessagingRoute
            ? 'flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden pt-[4.25rem]'
            : 'min-w-0 flex-grow pt-[4.25rem]'
        }
      >
        {children}
      </main>
      {!isMessagingRoute && <Footer />}
    </div>
  );
};

export default Layout;

